"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { VerdictHistoryEntry } from "./types";
import { useVerdictLabels } from "./meta";
import { FullHistoryRow } from "./HistoryItems";

interface FullHistoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  entries: VerdictHistoryEntry[];
}

/** Модалка «История заключения проктора(ов)» — полный скроллируемый журнал (десктоп) */
export default function FullHistoryModal({ open, onOpenChange, entries }: FullHistoryModalProps) {
  const labels = useVerdictLabels();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[560px]" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="text-base font-semibold">{labels.fullHistoryTitle}</DialogTitle>
        </DialogHeader>

        <div className="flex min-h-[30px] flex-[1_0_0] flex-col items-start self-stretch rounded-[6px] border border-[#E5E5E5] bg-[#F5F5F5] max-h-[60vh] overflow-y-auto">
          {entries.map((entry, i) => (
            <FullHistoryRow key={entry.id} entry={entry} striped={i % 2 === 0} />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
